import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule, Routes } from '@angular/router';

import { StepsModule } from 'primeng/steps';

import { HoldFileService } from '../services/hold-file-service/hold-file.service';

import { FleetFinderComponent } from '../routes/fleet-finder-component/fleet-finder.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';

const fleetFinderChildren: Routes = [];

const fleetFinderRoute: Route = {
  path: 'fleet-finder',
  component: FleetFinderComponent,
  data: { title: 'Fleet Finder' },
  children: fleetFinderChildren,
};

const fleetFinderRoutes: Routes = [fleetFinderRoute];

@NgModule({
  declarations: [FleetFinderComponent],

  imports: [
    CommonModule,
    StepsModule,
    RouterModule.forChild(fleetFinderRoutes),
    CheckboxModule,
    FormsModule,
    DropdownModule,
    DialogModule,
  ],

  providers: [HoldFileService],

  exports: [RouterModule],
})
export class FleetFinderRoutingModule {}
